export default __webpack_public_path__ + "static/media/l43.a6c158b1.png";